import React from 'react';
import styled from 'styled-components';
import { IconImage } from '@bynder/icons';
import { Button, token, Tooltip } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import { useNavigableItem } from '../../KeyboardNavigation';

type Props = {
	onClick: () => void;
};

/** Context for AI: trigger that opens the inline search-by-image panel (SearchByImagePanel.tsx). Rendered only when canUseSimilaritySearch. */
export function SearchByImageButton({ onClick }: Props) {
	const { translate } = useTranslate();
	const { isActive, itemRef } = useNavigableItem<HTMLButtonElement>(onClick, {
		afterSelect: 'none',
	});

	return (
		<Tooltip content={translate('spotlight.searchByImage')}>
			<StyledWrapper>
				<Button
					ref={itemRef}
					title=""
					variant="clean"
					icon={<IconImage />}
					isPressed={isActive}
					onClick={(event) => {
						event.stopPropagation();
						onClick();
					}}
					isSmall
					data-testid="search-by-image-spotlight-button"
				/>
			</StyledWrapper>
		</Tooltip>
	);
}

const StyledWrapper = styled.div`
	margin-left: calc(-1 * ${token.spacing3});
	margin-right: calc(-1 * ${token.spacing3});
`;
